<template>
	<dms-list-layout v-bind="layoutProps">
		<div slot="filter">
			<dms-collapse :value.sync="mainCollapse">
			<dms-collapse-item label-key="GeneralCriteria">
				<dms-group label-multi-key="DATE RANGE">
						<dms-date-picker :clearable="false" :span="12" :value.sync="fromDate" :disabled="false" label-key="OD"  />
						<dms-date-picker :clearable="false" :span="12" :value.sync="toDate" :disabled="false" label-key="DO"  />
				</dms-group>
			<dms-input :value.sync="Customer_ID" label-key="CUSTOMER_ID" />
			<dms-input :value.sync="Golden_Account_Number" label-key="GOLDEN_ACCOUNT_NUMBER" />
			</dms-collapse-item>
			</dms-collapse>
		</div>
		<dms-table slot="content" v-bind="tableModel" v-on="tableListeners" />
	</dms-list-layout>
</template>

<script>
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store);
</script>
